import { LearnersReliefListingsInvitation } from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type NewProps = {
  invitation: LearnersReliefListingsInvitation
}

export const useNewProps = () => useProps<NewProps>()
